var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('dashboard-layout', {
    attrs: {
      "tit": "비밀번호 변경"
    }
  }, [_c('template', {
    slot: "contents"
  }, [_c('vertical-form-table', {
    attrs: {
      "items": _vm.items
    },
    model: {
      value: _vm.inputs,
      callback: function callback($$v) {
        _vm.inputs = $$v;
      },
      expression: "inputs"
    }
  }, [_c('template', {
    slot: "새 비밀번호 확인"
  }, [_c('v-password-confirm-field', {
    attrs: {
      "password": _vm.inputs.newPassword,
      "outlined": ""
    },
    on: {
      "input": function input(value) {
        _vm.passwordConfirm = value;
      }
    },
    model: {
      value: _vm.passwordConfirm,
      callback: function callback($$v) {
        _vm.passwordConfirm = $$v;
      },
      expression: "passwordConfirm"
    }
  })], 1)], 2), _c('div', {
    staticClass: "v-btn-group"
  }, [_c('v-btn', {
    staticClass: "min-w-140px min-w-lg-160px",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_c('span', [_vm._v("비밀번호 변경")])])], 1)], 1)], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }